import { render } from "./Draft.vue?vue&type=template&id=5ea138da&scoped=true"
import script from "./Draft.vue?vue&type=script&lang=js"
export * from "./Draft.vue?vue&type=script&lang=js"

import "./Draft.vue?vue&type=style&index=0&id=5ea138da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea138da"]])

export default __exports__